import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "flex items-start justify-between gap-3"
};
const _hoisted_2 = {
  class: "min-w-0 flex-1"
};
const _hoisted_3 = {
  class: "form-label flex items-baseline gap-1"
};
const _hoisted_4 = {
  class: "mt-1 flex items-baseline gap-1.5 text-xs"
};
const _hoisted_5 = {
  class: "font-medium tabular-nums text-slate-500"
};
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["aria-valuenow", "aria-label"];
const _hoisted_8 = {
  class: "space-y-1.5"
};
const _hoisted_9 = {
  class: "flex items-center justify-between gap-2 border-b border-slate-100 px-2 py-1.5"
};
const _hoisted_10 = {
  class: "text-xs text-slate-500"
};
const _hoisted_11 = {
  class: "flex items-center gap-0.5"
};
const _hoisted_12 = ["disabled", "onClick"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "flex items-center justify-between gap-2"
};
const _hoisted_15 = ["onUpdate:modelValue", "disabled", "onBlur"];
const _hoisted_16 = ["disabled", "onClick"];
const _hoisted_17 = {
  key: 2
};
const _hoisted_18 = {
  key: 3
};
const _hoisted_19 = {
  key: 4
};
import { computed, reactive, watch } from 'vue';
import { CheckIcon, CheckCircleIcon, ExclamationCircleIcon, PlusIcon, TrashIcon } from '@heroicons/vue/24/outline';
import { DEFAULT_ENTERPRISE_INVOICE_PRODUCT_NAMES, ENTERPRISE_INVOICE_PRODUCT_NAMES } from '../productNames';
import { hasSameProductQuotaDrafts, normalizeProductQuotaDrafts, normalizeQuotaAmount, quotaTotalAmount, quotaTotalMatched } from '../productQuota';
export default {
  __name: 'InvoiceProductQuotaEditor',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    targetAmount: {
      type: Number,
      default: 0
    },
    amountStep: {
      type: Number,
      default: 100
    },
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const localQuotas = reactive([]);
    let nextLocalId = 1;
    let isEmittingLocalChange = false;
    const totalAmount = computed(() => quotaTotalAmount(localQuotas));
    const canAddRow = computed(() => usedProductNames().size < ENTERPRISE_INVOICE_PRODUCT_NAMES.length);
    const progressPercent = computed(() => {
      const target = normalizeQuotaAmount(props.targetAmount);
      if (target <= 0) return 0;
      const total = quotaTotalAmount(localQuotas);
      return Math.min(100, Math.round(total / target * 100));
    });
    const differenceAmount = computed(() => {
      const target = normalizeQuotaAmount(props.targetAmount);
      const total = quotaTotalAmount(localQuotas);
      return target - total;
    });
    function resetLocalQuotas(previousTargetAmount = null) {
      const incomingQuotas = normalizeProductQuotaDrafts(props.modelValue, props.targetAmount);
      if (hasSameProductQuotaDrafts(incomingQuotas, modelValueFromLocalQuotas())) {
        if (applyDefaultTargetAmount({
          previousTargetAmount,
          defaultEmpty: false
        })) {
          syncLocalQuotasToModel();
        }
        return;
      }
      localQuotas.splice(0, localQuotas.length);
      for (const quota of incomingQuotas) {
        localQuotas.push({
          localId: nextLocalId++,
          productNames: [...quota.productNames],
          displayAmount: quota.displayAmount
        });
      }
      applyDefaultTargetAmount({
        previousTargetAmount,
        defaultEmpty: true
      });
      syncLocalQuotasToModel();
    }
    function applyDefaultTargetAmount({
      previousTargetAmount = null,
      defaultEmpty = true
    } = {}) {
      const targetAmount = normalizeQuotaAmount(props.targetAmount);
      if (targetAmount <= 0 || localQuotas.length !== 1) return false;
      const onlyQuota = localQuotas[0];
      const currentAmount = normalizeQuotaAmount(onlyQuota.displayAmount);
      const hasPreviousTarget = previousTargetAmount !== null && previousTargetAmount !== undefined;
      const previousAmount = normalizeQuotaAmount(previousTargetAmount);
      const targetChanged = hasPreviousTarget && previousAmount !== targetAmount;
      if (defaultEmpty && currentAmount <= 0 || targetChanged && currentAmount === previousAmount) {
        onlyQuota.displayAmount = targetAmount;
        return true;
      }
      return false;
    }
    function modelValueFromLocalQuotas() {
      return localQuotas.map(quota => ({
        productNames: [...quota.productNames],
        displayAmount: normalizeQuotaAmount(quota.displayAmount)
      }));
    }
    function syncLocalQuotasToModel() {
      const nextValue = modelValueFromLocalQuotas();
      if (!hasSameProductQuotaDrafts(props.modelValue, nextValue)) {
        isEmittingLocalChange = true;
        emit('update:modelValue', nextValue);
      }
    }
    function emitChange() {
      isEmittingLocalChange = true;
      emit('update:modelValue', modelValueFromLocalQuotas());
    }
    function normalizeDisplayAmount(index) {
      const quota = localQuotas[index];
      if (!quota) return;
      quota.displayAmount = normalizeQuotaAmount(quota.displayAmount);
      emitChange();
    }
    function addQuotaRow() {
      const used = usedProductNames();
      const firstUnused = ENTERPRISE_INVOICE_PRODUCT_NAMES.find(name => !used.has(name));
      if (!firstUnused) return;
      localQuotas.push({
        localId: nextLocalId++,
        productNames: [firstUnused],
        displayAmount: 0
      });
      emitChange();
    }
    function removeQuotaRow(index) {
      if (localQuotas.length <= 1) return;
      localQuotas.splice(index, 1);
      emitChange();
    }
    function usedProductNames(ignoreIndex = -1) {
      const used = new Set();
      localQuotas.forEach((quota, index) => {
        if (index === ignoreIndex) return;
        for (const name of quota.productNames || []) used.add(name);
      });
      return used;
    }
    function availableProductNames(index) {
      const used = usedProductNames(index);
      return ENTERPRISE_INVOICE_PRODUCT_NAMES.filter(name => !used.has(name));
    }
    function isProductNameDisabled(name, index) {
      return usedProductNames(index).has(name);
    }
    function updateQuotaProductNames(index, productNames) {
      const quota = localQuotas[index];
      if (!quota) return;
      quota.productNames = productNames;
      emitChange();
    }
    function selectAvailableProductNames(index) {
      updateQuotaProductNames(index, availableProductNames(index));
    }
    function selectDefaultProductNames(index) {
      const available = new Set(availableProductNames(index));
      const defaults = DEFAULT_ENTERPRISE_INVOICE_PRODUCT_NAMES.filter(name => available.has(name));
      updateQuotaProductNames(index, defaults.length > 0 ? defaults : availableProductNames(index).slice(0, 1));
    }
    function formatAmount(value) {
      const amount = normalizeQuotaAmount(value);
      return amount.toLocaleString('zh-CN', {
        maximumFractionDigits: 0
      });
    }
    watch(() => [props.modelValue, props.targetAmount], (value, oldValue) => {
      if (isEmittingLocalChange && hasSameProductQuotaDrafts(props.modelValue, modelValueFromLocalQuotas())) {
        isEmittingLocalChange = false;
        return;
      }
      isEmittingLocalChange = false;
      resetLocalQuotas(oldValue?.[1] ?? null);
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createElementBlock("section", {
        class: _normalizeClass(['quota-editor space-y-2.5', __props.compact && 'is-compact'])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(__props.title), 1), _cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "text-red-500"
      }, "*", -1))]), _createElementVNode("div", _hoisted_4, [_cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "text-slate-400"
      }, "合计", -1)), _createElementVNode("span", {
        class: _normalizeClass(["font-semibold tabular-nums", totalAmount.value > 0 && !_unref(quotaTotalMatched)(localQuotas, __props.targetAmount) ? 'text-amber-600' : 'text-slate-900'])
      }, "¥" + _toDisplayString(formatAmount(totalAmount.value)), 3), _cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "text-slate-300"
      }, "/", -1)), _createElementVNode("span", _hoisted_5, "¥" + _toDisplayString(formatAmount(__props.targetAmount)), 1)])]), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary inline-flex items-center gap-1 px-2.5 py-1 text-xs",
        disabled: __props.disabled || !canAddRow.value,
        onClick: addQuotaRow
      }, [_createVNode(_unref(PlusIcon), {
        class: "h-3.5 w-3.5"
      }), _cache[5] || (_cache[5] = _createTextVNode(" 新增 ", -1))], 8, _hoisted_6)]), _createElementVNode("div", {
        class: "quota-editor__progress",
        role: "progressbar",
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-valuenow": progressPercent.value,
        "aria-label": `已分配 ${progressPercent.value}%`
      }, [_createElementVNode("div", {
        class: _normalizeClass(["quota-editor__progress-fill", _unref(quotaTotalMatched)(localQuotas, __props.targetAmount) ? 'is-matched' : 'is-pending']),
        style: _normalizeStyle({
          width: `${progressPercent.value}%`
        })
      }, null, 6)], 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localQuotas, (quota, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: quota.localId,
          class: "grid grid-cols-1 items-start gap-2 sm:grid-cols-[minmax(0,1fr)_120px_auto]"
        }, [_createVNode(_component_el_select, {
          modelValue: quota.productNames,
          "onUpdate:modelValue": $event => quota.productNames = $event,
          multiple: "",
          "collapse-tags": "",
          "collapse-tags-tooltip": "",
          "max-collapse-tags": __props.compact ? 1 : 2,
          filterable: "",
          "reserve-keyword": false,
          persistent: true,
          class: "form-select form-control-sm w-full",
          disabled: __props.disabled,
          placeholder: "选择品名",
          onChange: emitChange
        }, {
          header: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, "已选 " + _toDisplayString(quota.productNames.length) + " 项", 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("button", {
            type: "button",
            class: "rounded px-1.5 py-0.5 text-xs font-medium text-primary-600 transition-colors hover:bg-primary-50 disabled:cursor-not-allowed disabled:text-slate-300",
            disabled: availableProductNames(index).length === 0,
            onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent", "stop"])),
            onClick: _withModifiers($event => selectAvailableProductNames(index), ["stop"])
          }, " 全选可用 ", 40, _hoisted_12), _createElementVNode("button", {
            type: "button",
            class: "rounded px-1.5 py-0.5 text-xs font-medium text-primary-600 transition-colors hover:bg-primary-50",
            onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent", "stop"])),
            onClick: _withModifiers($event => selectDefaultProductNames(index), ["stop"])
          }, " 默认 ", 40, _hoisted_13)])])]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ENTERPRISE_INVOICE_PRODUCT_NAMES), name => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: name,
              label: name,
              value: name,
              disabled: isProductNameDisabled(name, index)
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("span", null, _toDisplayString(name), 1), quota.productNames.includes(name) ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                key: 0,
                class: "h-3.5 w-3.5 text-primary-600"
              })) : _createCommentVNode("", true)])]),
              _: 2
            }, 1032, ["label", "value", "disabled"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue", "max-collapse-tags", "disabled"]), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": $event => quota.displayAmount = $event,
          type: "text",
          inputmode: "decimal",
          class: "form-input form-control-sm w-full text-right tabular-nums",
          disabled: __props.disabled,
          placeholder: "0",
          onInput: emitChange,
          onBlur: $event => normalizeDisplayAmount(index)
        }, null, 40, _hoisted_15), [[_vModelText, quota.displayAmount]]), _createElementVNode("button", {
          type: "button",
          class: "table-action-button is-danger justify-self-end sm:mt-0.5 sm:justify-self-auto",
          title: "删除",
          "aria-label": "删除",
          disabled: __props.disabled || localQuotas.length <= 1,
          onClick: $event => removeQuotaRow(index)
        }, [_createVNode(_unref(TrashIcon), {
          class: "h-3.5 w-3.5"
        })], 8, _hoisted_16)]);
      }), 128))]), _createElementVNode("div", {
        class: _normalizeClass(['quota-editor__status flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs', _unref(quotaTotalMatched)(localQuotas, __props.targetAmount) ? 'is-matched' : 'is-pending'])
      }, [_unref(quotaTotalMatched)(localQuotas, __props.targetAmount) ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
        key: 0,
        class: "h-3.5 w-3.5 flex-shrink-0"
      })) : (_openBlock(), _createBlock(_unref(ExclamationCircleIcon), {
        key: 1,
        class: "h-3.5 w-3.5 flex-shrink-0"
      })), _unref(quotaTotalMatched)(localQuotas, __props.targetAmount) ? (_openBlock(), _createElementBlock("span", _hoisted_17, "金额合计已匹配目标额度")) : differenceAmount.value > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_18, "金额合计需等于目标额度，还需分配 ¥" + _toDisplayString(formatAmount(differenceAmount.value)), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_19, "金额合计需等于目标额度，超出 ¥" + _toDisplayString(formatAmount(Math.abs(differenceAmount.value))), 1))], 2)], 2);
    };
  }
};